import(/* webpackMode: "eager" */ "/Users/lorion/Documents/code/clipglobe/web/app/[locale]/globals.css");
;
import(/* webpackMode: "eager" */ "/Users/lorion/Documents/code/clipglobe/web/app/[locale]/feedback.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/components/Analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/components/Background.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/components/FeedbackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/components/SiteFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/components/SiteHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/Users/lorion/Documents/code/clipglobe/web/lib/auth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PendingFilesProvider"] */ "/Users/lorion/Documents/code/clipglobe/web/lib/pending-files.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/Users/lorion/Documents/code/clipglobe/web/lib/toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
